<template>
  <div>
    <Navbar></Navbar>
    <div class="container mt-3 mt-lg-5">

      <!-- TITLE -->
      <div class="row mb-3">
        <div class="col-md-12 mb-3">
          <router-link to="/palettes" class="btn btn-link btn-micint-xr ripple ripple-primary m-0">
            <i class="material-icons-outlined">arrow_left</i>
            Go back
          </router-link>
        </div>
        <div class="col-6 col-md-6 align-self-center">
          <vue-aos animation-class="animate__animated animate__flipInX">
            <h1 class="typography-headline-lg fw-500 text-uppercase">{{ palette.name }}</h1>
          </vue-aos>
        </div>
        <div class="col-6 col-md-6 text-end">

          <!-- MODAL SHARE -->
          <button class="btn btn-default-outline ripple ripple-primary d-none d-md-inline-block" data-bs-toggle="modal"
                  data-bs-target="#shareModal">
            <i class="material-icons-outlined me-md-1">share</i>
            <span class="d-none d-md-inline-block">Share</span>
          </button>
          <ModalPaletteShare :palette="palette" id="shareModal"></ModalPaletteShare>

          <!-- OFFCANVAS SHARE -->
          <a class="btn btn-default-outline ripple ripple-primary d-inline-block d-md-none" data-bs-toggle="offcanvas"
             href="#shareOffcanvas" role="button"
             aria-controls="shareOffcanvas">
            <i class="material-icons-outlined me-md-1">share</i>
          </a>
          <BottomDrawerPalette :palette="palette" id="shareOffcanvas"></BottomDrawerPalette>

        </div>
      </div>

      <!-- PALETTE -->
      <div class="row mb-3">
        <div class="col-md-12">
          <div class="palette palette-h-lg d-flex justify-content-around" id="expanded-palette"
               :class="[ isExpanded ? 'section-overlay' : '']">
            <div class="palette-item" :style="{'background': palette.color1}" @click="copyColor1()">
              <div class="palette-color">{{ palette.color1 }}</div>
            </div>
            <div class="palette-item" :style="{'background': palette.color2}" @click="copyColor2()">
              <div class="palette-color">{{ palette.color2 }}</div>
            </div>
            <div class="palette-item" :style="{'background': palette.color3}" @click="copyColor3()">
              <div class="palette-color">{{ palette.color3 }}</div>
            </div>
            <div class="palette-item" :style="{'background': palette.color4}" @click="copyColor4()">
              <div class="palette-color">{{ palette.color4 }}</div>
            </div>
            <div class="palette-item" :style="{'background': palette.color5}" @click="copyColor5()">
              <div class="palette-color">{{ palette.color5 }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- BUTTONS ACTIONS -->
      <div class="row mb-3">
        <div class="col-md-12">

          <button class="btn btn-primary-light ripple ripple-primary" @click="toggleSidebarCodes">
            <i class="material-icons-outlined">code</i>
            Custom color codes
          </button>
          <SidebarCodesPalette :is-sidebar-active="isSidebarActive" :palette="palette"
                               :sidebar-toggle="toggleSidebarCodes"></SidebarCodesPalette>

          <!-- <button class="btn btn-primary-light ripple ripple-primary" data-bs-toggle="modal"
                            data-bs-target="#androidModal">
                      <i class="material-icons-outlined">android</i>
                      Android colors
                    </button> -->
          <!-- MODAL ANDROID COLORS -->
          <!-- <ModalPaletteAndroid :palette="palette" id="androidModal"></ModalPaletteAndroid>-->

          <!-- EXPAND BUTTON -->
          <button class="btn btn-fab m-0" @click="expandPalette"><i
              class="material-icons-outlined btn-fab-icon">{{ isExpanded ? 'close' : 'fullscreen' }}</i>
          </button>

          <!-- DOWNLOAD BUTTON -->
          <button class="btn btn-fab btn-fab-download m-0" @click="downloadPalette"
                  :class="[ isExpanded ? 'd-block' : 'd-none']"><i
              class="material-icons-outlined btn-fab-icon">download</i>
          </button>

        </div>
      </div>

      <!-- TABLE COLOR CONVERTER -->
      <div class="row mb-5">
        <div class="col-md-12">
          <TablePaletteColors :palette="palette"></TablePaletteColors>
        </div>
      </div>

      <!-- TESTING PALETTE -->
      <div class="row mb-3">
        <div class="col-md-12 mb-3">
          <h2 class="fw-500 typography-headline-md">How it looks?</h2>
          <h3 class="subtitle-1"><span class="fw-bold text-gradient-animate">Note:</span> The color blindness filters
            doesn't work on some browsers</h3>
        </div>
        <div class="col-md-12 mb-3">
          <PaletteTesting :palette="palette"></PaletteTesting>
        </div>
      </div>

      <!-- ICONS WITH PALETTE COLORS -->
      <div class="row mb-3">
        <div class="col-md-12 mb-3">
          <h2 class="fw-500 typography-headline-md">Palette on icons</h2>
        </div>
        <div class="col-md-12 mb-3">
          <PaletteIcons :palette="palette"></PaletteIcons>
        </div>
      </div>

    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Navbar from "@/components/includes/Navbar";
import Footer from "@/components/includes/Footer";
import VueAos from 'vue-aos'
import firebase from 'firebase/app'
import 'firebase/firestore'
// import ModalPaletteAndroid from "@/components/palettes/ModalPaletteAndroid";
import TablePaletteColors from "@/components/palettes/TablePaletteColors";
import PaletteTesting from "@/components/palettes/PaletteTesting";
import PaletteIcons from "@/components/palettes/PaletteIcons";
import ModalPaletteShare from "@/components/palettes/ModalPaletteShare";
import * as htmlToImage from 'html-to-image';
import BottomDrawerPalette from "@/components/palettes/BottomDrawerPalette";
import SidebarCodesPalette from "@/components/palettes/SidebarCodesPalette";

export default {
  name: 'Palette',
  metaInfo() {
    return {
      title: this.palette.name + ' | Palette',
    }
  },
  data() {
    return {
      palette: {},
      isExpanded: false,
      isSidebarActive: false
    }
  },
  components: {
    SidebarCodesPalette,
    BottomDrawerPalette,
    ModalPaletteShare,
    PaletteIcons, PaletteTesting, TablePaletteColors /*ModalPaletteAndroid*/, Navbar, Footer, VueAos
  },
  mounted() {
    this.getPalette()
  },
  methods: {
    async getPalette() {
      const db = firebase.firestore()
      const palette = await db.collection('palettes').doc(this.$route.params.paletteId).get()
      this.palette = {id: palette.id, ...palette.data()}
    },
    expandPalette() {
      this.isExpanded = !this.isExpanded
    },
    toggleSidebarCodes() {
      this.isSidebarActive = !this.isSidebarActive
    },
    downloadPalette() {
      htmlToImage.toJpeg(document.getElementById('expanded-palette'), {quality: 1})
          .then(function (dataUrl) {
            const link = document.createElement('a');
            link.download = 'palette.jpeg';
            link.href = dataUrl
            link.click();
          })
    },
    copyColor1() {
      this.$clipboard(this.palette.color1)
      this.$swal({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        icon: 'success',
        title: 'Color ' + this.palette.color1 + ' copied',
      })
    },
    copyColor2() {
      this.$clipboard(this.palette.color2)
      this.$swal({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        icon: 'success',
        title: 'Color ' + this.palette.color2 + ' copied',
      })
    },
    copyColor3() {
      this.$clipboard(this.palette.color3)
      this.$swal({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        icon: 'success',
        title: 'Color ' + this.palette.color3 + ' copied',
      })
    },
    copyColor4() {
      this.$clipboard(this.palette.color4)
      this.$swal({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        icon: 'success',
        title: 'Color ' + this.palette.color4 + ' copied',
      })
    },
    copyColor5() {
      this.$clipboard(this.palette.color5)
      this.$swal({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        icon: 'success',
        title: 'Color ' + this.palette.color5 + ' copied',
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.palette {
  transition: none !important;
}

.palette-color {
  font-size: 1rem !important;
}

.section-overlay {
  &.palette-h-lg {
    overflow-y: hidden;

    .palette-item:first-child {
      border-top-left-radius: 0 !important;
      border-bottom-left-radius: 0 !important;
    }

    .palette-item:last-child {
      border-top-right-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
    }

    .palette-item {
      &:hover {
        width: 20% !important;

        .palette-color {
          display: none;
        }
      }
    }
  }
}
</style>